import { RefObject, useLayoutEffect, useRef, useState } from "react";

const getWidthWithMargins = (element: Element) => {
  if (!element) return 0;
  const style = getComputedStyle(element);
  const width = element.clientWidth;
  const marginLeft = parseFloat(style.marginLeft);
  const marginRight = parseFloat(style.marginRight);
  return width + marginLeft + marginRight;
};

const useMoreVisibleItems = (
  itemCount: number,
  childrenRef?: RefObject<HTMLElement>
) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const moreRef = useRef<HTMLDivElement>(null);
  const [count, setCount] = useState(itemCount);

  const childrenWidth = childrenRef?.current?.offsetWidth ?? 0;
  useLayoutEffect(() => {
    if (!containerRef?.current) return;

    const containerWidth =
      containerRef.current.offsetWidth -
      (moreRef?.current?.offsetWidth ?? 0) -
      childrenWidth;
    let totalWidth = 0;
    let newCount = 0;

    for (let i = 0; i < itemCount; i++) {
      const element = containerRef.current.children[i];
      const itemWidth = getWidthWithMargins(element);

      const newWidth = totalWidth + itemWidth;
      if (newWidth < containerWidth) {
        totalWidth = newWidth;
        newCount = i + 1; // Adjusted to count the number of items that fit
      } else {
        break;
      }
    }

    setCount(newCount);
  }, [itemCount]);

  return { count, containerRef, moreRef };
};

export default useMoreVisibleItems;
